module.exports = __webpack_public_path__ + "static/media/Atomslogo-rotated2-lightgreen.fa1f6edd.png";